'use client';

import React, { useState } from 'react';
import styles from './styles.module.scss';
import Tooltip from '@/app/ui/components/tooltip/tooltip';
import { useTranslation } from 'next-i18next';

export function TransparencyObligation() {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation(['filters']);

  const onClickHandler = (): void => {
    setOpen(!isOpen);
  };

  const getInfo = () => {
    return (
      <span>
        {t('INFO_TEXT')}
        <a href={'/faq/#produktsuche'} rel={'noreferrer'} target={'_blank'}>
          {t('HERE')}
        </a>
      </span>
    );
  };

  return (
    <div style={{ position: 'relative' }}>
      <div className={styles['infoIcon']} onClick={() => onClickHandler()} />
      {isOpen && (
        <Tooltip isOpen={isOpen} onCloseTooltip={onClickHandler}>
          <div className="text-center">{getInfo()}</div>
        </Tooltip>
      )}
    </div>
  );
}
